import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const FoodWrapPaper = () => <ProductDetailPage {...getProductPageConfig('foodWrapPaper')} />;

export default FoodWrapPaper;
